<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader :title="`${pageTitle}`">
        <el-form class="filter-wrapper se" label-width="50px">
          <el-col :span="role != 2 ? 10 : 5" v-role="[2, 3, 13]">
            <el-form-item label="Province" label-width="60px">
              <el-select v-model="province" placeholder="Please select province" class="month-select"
                @change="provinceChange">
                <el-option v-for="(item, i) in provinceList" :key="i" :label="item.provinceLabel"
                  :value="item.provinceValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="role != 2 ? 10 : 5" v-role="[2, 3, 13]">
            <el-form-item label="City">
              <el-select v-model="city" placeholder="Please select city" class="month-select" @change="cityChange">
                <el-option v-for="(city, i) in cityList" :key="i" :label="city.label" :value="city.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-role="[2]">
            <el-form-item label="Type">
              <el-select v-model="typeId" placeholder="Please select type" :loading="typeLoading" class="month-select"
                @change="typeSelectChange">
                <el-option v-for="item in typeOptions" :key="item.typeid" :label="item.typedescription"
                  :value="item.typeid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-role="[2]">
            <el-form-item label="User">
              <el-select v-model="user" placeholder="Please select User" filterable @change="userChange">
                <el-option v-for="(item, idx) in mlListOptions" :key="idx" :label="item.MLName" :value="item.MLID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <el-input prefix-icon="el-icon-search" style="width: 100px;" placeholder="Search" v-model="searchVal"
          v-debounce="onSearch" clearable @clear="onSearch" />
        <el-button v-role="[3, 13]" type="primary" icon="el-icon-plus" @click="importSEDialogVieible = true">
          New {{ isVMSL ? 'vCE' : 'HCP' }}
        </el-button>
        <el-dropdown trigger="click" @command="handleUploadCallCenter" v-role="[1]">
          <el-button type="primary" class="ml10">
            Call Center & vCE<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu class="export-dropdown" slot="dropdown">
            <el-dropdown-item icon="el-icon-upload2" command="1">
              Import<import-div-callCenter :action="'/vCE/importCallCenter'" @success="callCenterUpload" />
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-download" command="2" >
              Export
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-download" command="3" >
              Import Template
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="handleUpload" v-role="[1, 2]">
          <el-button type="primary" class="ml10">
            New HCP <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu class="export-dropdown" slot="dropdown">
            <el-dropdown-item icon="el-icon-upload2" command="1">
              Single Add
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-upload2" command="2" v-role="[1]">
              <import-div @success="operateUpload" />
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-upload2" command="3" v-role="[2]">
              Batch Add
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="handleCommand" v-role="[1]">
          <el-button type="primary" class="ml10">
            Export <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu class="export-dropdown" slot="dropdown">
            <el-dropdown-item icon="el-icon-download" command="1">
              User List
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-download" command="2">
              HCP List
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-download" command="3">
              Import Template
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" class="ml10" @click="filterExportSEList" v-role="[2, 3, 13]">
          Export
        </el-button>
         <el-button :loading="refreshLoading" v-role="[2, 3, 13]" type="primary" icon="el-icon-refresh" @click="refreshWeCom">
          Refresh WeCom
        </el-button>
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table ref="table" :data="tableData" v-loading="tableLoading" element-loading-text="Loading..."
        @sort-change="onSortChange" @select="handleSelect" @select-all="handleSelectionAll">
        <template>
          <el-table-column type="selection" width="45" align="center" />
        </template>
        <el-table-column prop="No"  width="80" label="No." sortable="custom" align="center" v-if="role !== 1" />
        <el-table-column prop="SEName" label="Name" min-width="110" sortable="custom" />
        <el-table-column prop="Province" label="Province" min-width="110" sortable="custom" />
        <el-table-column prop="City" label="City" min-width="80" sortable="custom" />
        <el-table-column prop="hospital" label="Hospital / Institution" min-width="180" sortable="custom" />
        <el-table-column prop="Department" label="Department" min-width="140" sortable="custom" />
        <el-table-column prop="Phone" label="Phone" min-width="100" sortable="custom"/>
        <el-table-column prop="LastPushDate" label="Last Push Date" min-width="150" sortable="custom" />
        <el-table-column prop="Types" label="Type" min-width="100" sortable="custom" />
        <el-table-column prop="Tags" label="Tag" min-width="200">
          <template slot-scope="{ row }">
            <hcp-tag-cell :value="row.Tags" />
          </template>
        </el-table-column>
        <el-table-column prop="EngagementProfile" label="Engagement Profile" width="180" sortable="custom" show-overflow-tooltip/>
        <el-table-column prop="MLName" label="MSL" min-width="100" sortable="custom" v-if="!isVMSL" />
        <el-table-column prop="vMLName" label="vMSL" min-width="100" sortable="custom" v-if="!isMSL" />
        <el-table-column prop="TeamName" label="Team" min-width="130" sortable="custom" />
        <el-table-column prop="IsWeComEnabled" width="200" label="WeCom Contacts" sortable="custom" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParserForWeComContacts(row.IsWeComEnabled)" effect="dark">
              {{ tagLabelParserForWeComContacts(row.IsWeComEnabled) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Match" width="160" label="iDoctor Match" sortable="custom">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParserForiDoctor(row.iDoctorStatus)" effect="dark">
              {{ tagLabelParserForiDoctor(row.iDoctorStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Certified" width="150" label="eMSL Certified" sortable="custom">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParser(row.Active)" effect="dark">
              {{ tagLabelParser(row.Active) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="AcceptedNewTerms" width="200" label="Accepted New Terms" sortable="custom" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParserForAcceptedNewTerms(row.AcceptedNewTerms)" effect="dark">
              {{ tagLabelParserForAcceptedNewTerms(row.AcceptedNewTerms) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Operation" width="100" prop="StatusDesc" align="center">
          <template slot-scope="{ row }" prop="StatusDesc">
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18">
              <OptionMenuItem v-role="[1, 2, 3, 13]" icon="iconfont icon-read" title="View"
                @click="goToViewPage(row)" />
              <OptionMenuItem v-role="[1, 2, 3]" icon="el-icon-edit" title="Edit" v-if="!row.source || !row.hcpid"
                @click="handleEdit(row)" />
              <OptionMenuItem v-role="[1, 2, 3, 13]" icon="iconfont icon-qrcode" title="QR Code"
                @click="getQRCode(row)" />
              <OptionMenuItem v-role="[1, 2]" icon="el-icon-delete" title="Delete" @click="handleDelete(row.SEID)" />
              <OptionMenuItem v-role="[2, 13]" icon="iconfont icon-read" title="SR Menu" v-if="row.Types === 'vCE'"
                @click="goToSRMenuPage(row)" />
              <OptionMenuItem v-if="row.Active == 2" icon="iconfont el-icon-s-claim" title="Resend Term"
                @click="goToResendTerm(row)" />
            </OptionMenu>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <div class="actions">
          <el-button v-role="[1]" type="text" icon="el-icon-delete" size="medium" @click="handleMultiDelete()"
            :disabled="multipleSelection.length === 0">
            Mass Delete
          </el-button>
          <el-button v-role="[1, 2, 3, 13]" type="text" icon="iconfont icon-transfer" size="medium"
            @click="handleTransferSE()" :disabled="multipleSelection.length === 0">
            Mass Transfer
          </el-button>
          <!-- <el-button v-role="[1, 2, 13]" type="text" icon="iconfont icon-transfer" size="medium"
            @click="handleTransferSE('vCE')" :disabled="multipleSelection.length === 0">
            Mass Transfer vCE
          </el-button> -->
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :pager-count="pagerCount" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <EditSEDialog :visible.sync="editSEDialogVisible" :data.sync="rowData" @success="onSuccess" />
    <QRCodeDialog :visible.sync="qrcodeDialogVisible" :data.sync="rowData" :title="qrTitle" />
    <TransferSEDialog :visible.sync="transferSEDialogVisible" :data.sync="seIds" @success="onSuccess"
      :type="transferType" pageType="SEList"/>
    <ImportSEDialog :visible.sync="importSEDialogVieible" @success="onSuccess(true)" />
    <BatchAddDialog ref="batchAddDialog" @success="operateUpload" />
    <TableDialog ref="tableDialog" @success="onSuccess(true)" />
    <el-dialog
      title="Call center&vCE Import Result"
      :visible.sync="callCenterUploadDialogVisible"
      width="520px"
      :close-on-click-modal="false"
      @closed="onCallCenterUploadDialogClosed"
    >
      <div class="call-center-upload-result">
        <div class="call-center-upload-row mb10">
          <span class="call-center-upload-label">Complete Count：</span>
          <span class="call-center-upload-value">{{ callCenterCompleteCount }}</span>
        </div>
        <div class="call-center-upload-row mb10">
          <span class="call-center-upload-label">Failed Count：</span>
          <span class="call-center-upload-value">{{ callCenterFailedCount }}<el-button v-if="callCenterFailedCount > 0" class="call-center-export-btn" type="primary" icon="el-icon-download"
            @click="exportCallCenterUploadError">
            Export
          </el-button></span>
          
        </div>
        <div class="mb10" v-if="callCenterFailedCount > 0">
          <!-- Keep layout consistent with backend error export button -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCallCenterUploadSubmit">
          Ok
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCodeDialog from "./qrcode-dialog";
import EditSEDialog from "./edit-se-dialog";
import TransferSEDialog from "./transfer-se-dialog";
import ImportSEDialog from "./import-se-dialog";
import BatchAddDialog from "./batch-add-dialog";
import downloadjs from "downloadjs";
import ImportDiv from "./import-div";
import ImportDivCallCenter from "./import-div-callCenter";
import { RoleCode } from "@/utils/role-constant";
import TableDialog from "./table-dialog";
import HcpTagCell from "@/components/hcp-tag-cell.vue";

export default {
  name: "My-SE",
  components: {
    ImportSEDialog,
    QRCodeDialog,
    EditSEDialog,
    TransferSEDialog,
    ImportDiv,
    BatchAddDialog,
    TableDialog,
    ImportDivCallCenter,
    HcpTagCell,
  },
  data() {
    return {
      tableLoading: true,
      searchVal: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreatedOn",
      orderType: "descending",
      qrcodeDialogVisible: false,
      importSEDialogVieible: false,
      editSEDialogVisible: false,
      rowData: null,
      qrcodeUrl: "",
      multipleSelection: [],
      seIds: null,
      transferSEDialogVisible: false,
      transferType: '',
      qrTitle: 'SE/CE',
      typeid: '',
      typeLoading: false,
      typeOptions: [{
        typedescription: 'All',
        typeid: ''
      }],
      cityList: [],
      provinceList: [],
      province: '',
      city: '',
      user: '',
      typeId: '',
      mlList: [],
      refreshLoading: false,
      callCenterUploadDialogVisible: false,
      callCenterCompleteCount: 0,
      callCenterFailedCount: 0,
      callCenterFailedRows: [],
      callCenterErrorId: null,
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    templateUrl() {
      if (this.role === RoleCode.Admin) {
        return "/template/SEUserImportTemplate.xlsx";
      } else {
        return "/template/SupSEUserImportTemplate.xlsx";
      }
    },
    pagerCount() {
      let clientWidth = document.body.clientWidth;
      return clientWidth <= 1024 ? 5 : 7;
    },
    pageTitle() {
      return this.isVMSL ? 'vCE List' : 'HCP List'
    },
    isVMSL() {
      return this.role === RoleCode.VMSL;
    },
    isMSL() {
      return this.role === RoleCode.ML;
    },
    mlName() {
      let ml = this.mlListOptions.find((item) => item.MLID === this.form.mlId);
      return ml ? ml.MLName : "";
    },
    mlListOptions() {
      return this.mlList
    },
  },
  created() {
    this.getTableData();
    this.setProvince()
    this.getType()
    this.getMlList();
    this.bus.$on("refresh", ({ name }) => {
      console.log(name)
      if (name === "My-SE/CE" || name === 'HCP List' || name === 'vCE List' || name === 'SE/CE List') {
        this.getTableData();
      }
    });
  },
  methods: {
    refreshWeCom(){
      // 如果是角色2（Supervisor），先显示弹窗提示
      if (this.role === 2) {
        this.$confirm('仅能更新与您有绑定关系的HCP企业微信添加状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户点击确定，执行接口调用
          this.callRefreshWeComApi();
        }).catch(() => {
          // 用户点击取消，不执行任何操作
        });
      } else {
        // 角色3和13，直接调用接口
        this.callRefreshWeComApi();
      }
    },
    // 封装调用刷新企业微信接口的逻辑
    callRefreshWeComApi() {
      this.refreshLoading = true
      this.axios
        .get(`/se/refreshWeCom`)
        .then(({ code, msg }) => {
          if (200 === code) {
            this.$message({
              type: "success",
              message: 'Refresh WeCom Success.',
            });
            this.getTableData();
             this.refreshLoading = false
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
             this.refreshLoading = false
          }
        })
        .catch(() => {
           this.refreshLoading = false
        });
    },
    provinceChange() {
      this.city = ''
      if (this.province) {
        this.cityList = this.getCityListByProvince(this.province, this.provinceList);
      } else {
        let cityList =[]
        this.provinceList.forEach(item => {
          cityList = cityList.concat(item.cities);
        });
        this.cityList = [
          {
            label: "All",
            value: "",
          },
        ].concat(cityList.filter(city => city != null && city.trim() !== "").map(item => {
          return {
            label: item,
            value: item,
          }
        }))
      }
      this.currentPage = 1;
      this.getTableData();
    },

    tagTypeParserForAcceptedNewTerms(flag) {
      let type = ''
      switch (flag) {
        case '0':
          type = 'danger'
          break;
        case '1':
          type = 'success'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagTypeParserForWeComContacts(flag) {
      let type = ''
      switch (flag) {
        case 0:
          type = 'danger'
          break;
        case 1:
          type = 'success'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagLabelParserForWeComContacts(flag) {
      let label = ''
      switch (flag) {
        case 0:
          label = 'No'
          break;
        case 1:
          label = 'Yes'
          break;
        default:
          label = 'No'
          break;
      }
      return label
    },
    tagLabelParserForAcceptedNewTerms(flag) {
      let label = ''
      switch (flag) {
        case '0':
          label = 'No'
          break;
        case '1':
          label = 'Yes'
          break;
        default:
          label = 'No'
          break;
      }
      return label
    },
    getCityListByProvince(province, dataList) {
      const provinceData = dataList.find(item => item.provinceValue === province);
      return provinceData ? [
        {
          label: "All",
          value: "",
        },
      ].concat(provinceData.cities.map(item => {
        return {
          label: item,
          value: item,
        }
      })) : [];
    },
    cityChange() {
      // this.updateProvinceByCity(this.city);
      this.currentPage = 1;
      this.getTableData();
    },
    userChange() {
      this.currentPage = 1;
      this.getTableData();
    },
    updateProvinceByCity(selectedCity) {
      for (const item of this.provinceList) {
        if (item?.cities?.includes(selectedCity)) {
          this.province = item.province;
          return;
        }
      }
    },
    getMlList() {
      this.axios
        .get(`/meetingStatistics/mlList`)
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.mlList = [
              {
                MLName: "All",
                MLID: "",
                TeamID: "",
              },
            ].concat(data);
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        })
        .catch(() => {
        });
    },
    getType() {
      this.typeLoading = true;
      this.axios
        .get(`/sys/getHcpType`)
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.typeOptions = [{
              typedescription: 'All',
              typeid: ''
            },
            ...data]
            this.form.typeId = ''
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.typeLoading = false;
        })
        .catch(() => {
          this.typeLoading = false;
        });
    },
    setProvince() {
      this.axios
        .get(`/sys/getProvinceCityMap`)
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.provinceList = [
              {
                provinceLabel: "All",
                provinceValue: "",
              },
            ].concat(data.map(item => {
              return {
                ...item,
                provinceLabel: item.province,
                provinceValue: item.province
              }
            }));
            let cityList = [];
            data.forEach(item => {
              cityList = cityList.concat(item.cities);
            });
            this.cityList = [
              {
                label: "All",
                value: "",
              },
            ].concat(cityList.map(item => {
              return {
                label: item,
                value: item,
              }
            }))
            this.$store.commit("updateState", {
              province: data
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        })
        .catch(() => {
        });
    },
    goToSRMenuPage(row) {
      const SEID = row.SEID || ''
      const mlId = row.MLID || ''
      this.$router.push({ name: 'sr-menu', params: { seId: SEID, mlId } })
    },
    typeSelectChange() {
      this.currentPage = 1;
      this.getTableData();
    },
    goToResendTerm(row) {
      this.axios
        .post(`/se/resendTerms`, {
          seId: row.SEID,
        })
        .then(({ code, msg }) => {
          if(code  && code !== 200){
            this.$message.error(msg);
          }else{
            this.$message.success("Resend terms successfully");
            this.getTableData();
          }
        })
        .catch(() => {
        });
    },
    goToViewPage(row) {
      const SEID = row.SEID || ''
      const MLID = row.MLID || 'noML'
      this.$router.push(`/se/${SEID}/${MLID}`)
    },
    callCenterUpload(data) {
      // 上传接口返回：{ successCount, errorCount, errorId }
      const d = data || {}
      this.callCenterCompleteCount = Number(d.successCount) || 0
      this.callCenterFailedCount = Number(d.errorCount) || 0
      this.callCenterErrorId = d.errorId != null && d.errorId !== '' ? d.errorId : null
      this.callCenterFailedRows = []
      this.callCenterUploadDialogVisible = true
    },
    onCallCenterUploadSubmit() {
      this.callCenterUploadDialogVisible = false;
      this.onSuccess(true);
    },
    onCallCenterUploadDialogClosed() {
      this.callCenterCompleteCount = 0;
      this.callCenterFailedCount = 0;
      this.callCenterFailedRows = [];
      this.callCenterErrorId = null;
    },
    async exportCallCenterUploadError() {
      if (!this.callCenterErrorId) {
        this.$message.warning('No error export is available.')
        return
      }
      const loading = this.$message({
        message: 'Exporting error file...',
        duration: 0,
      })
      try {
        const res = await this.axios.post(
          '/vCE/exportCallCenterErrorInfo',
          { errorId: this.callCenterErrorId },
          { responseType: 'blob' },
        )
        if (res && res.data && res.data.file) {
          downloadjs(
            res.data.file,
            (res.data.fileName || 'Call_center_vCE_Import_Error_Message.xlsx').replace(/^"|"$/g, ''),
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          )
          this.$message.success('Error file exported successfully.')
        } else {
          this.$message.error('Export failed.')
        }
      } catch (e) {
        this.$message.error('Export failed.')
      } finally {
        loading.close()
      }
    },
    operateUpload(data) {
      if (data && data.mode === 'async') {
        const jobs = data.jobs && data.jobs.length
          ? data.jobs
          : data.jobId
            ? [{ jobId: data.jobId, queuePosition: data.queuePosition }]
            : []
        const queuedCount = jobs.filter((j) => Number(j.queuePosition) > 1).length
        let msg = ''
        if (jobs.length > 1) {
          msg = queuedCount > 0
            ? `${jobs.length} tasks submitted (Batch Add and Transfer/Delete). ${queuedCount} task(s) queued. View progress in Batch Operation tool.`
            : `${jobs.length} tasks submitted. View progress in Batch Operation tool.`
        } else if (queuedCount === 1) {
          msg = `Task submitted. Queue position: ${jobs[0].queuePosition}. View progress in Batch Operation tool.`
        } else {
          msg = 'Batch operation task submitted. View progress in Batch Operation tool.'
        }
        this.$message.success(msg)
        this.$router.push('/batch-operation-tool').then(() => {
          this.bus.$emit('refresh', { name: 'Batch Operation tool' })
        })
        return
      }
      this.$refs.tableDialog.open(data);
    },
    handleUpload(command) {
      switch (command) {
        case "1":
          this.importSEDialogVieible = true;
          break;
        case "3":
          this.$refs.batchAddDialog.open();
          break;
      }
    },
    handleUploadCallCenter(command) {
      switch (command) {
        case "1":
          break;
        case "2":
          this.exportCallCenterList();
          break;
        case "3":
          this.downloadCallCenterImportTemplate();
          break;
      }
    },
    handleCommand(command) {
      switch (command) {
        case "1":
          this.exportMSLList();
          break;
        case "2":
          this.exportSEList();
          break;
        case "3":
          this.downloadTemplate();
          break;
      }
    },
    downloadTemplate() {
      this.axios
        .get(this.templateUrl, {
          baseURL: "/",
          responseType: "blob",
        })
        .then((data) => {
          downloadjs(
            data,
            `HCP_Import_Template.xlsx`,
            "application/vnd.ms-excel"
          );
          this.$message.success(`Download import template  successful!`);
        });
    },
    downloadCallCenterImportTemplate() {
      this.axios
        .get("/template/CallCenterImportTemplate.xlsx", {
          baseURL: "/",
          responseType: "blob",
        })
        .then((data) => {
          downloadjs(
            data,
            "CallCenterImportTemplate.xlsx",
            "application/vnd.ms-excel"
          );
          this.$message.success("Download Call Center import template successful!");
        });
    },
    exportCallCenterList() {
      const msg = this.$message({
        message: "Call Center list is exporting...",
        duration: 0,
      });
      this.axios
        .get("/se/callCenterExport", {
          responseType: "blob",
        })
        .then(({ data }) => {
          downloadjs(
            data.file,
            data.fileName,
            "application/vnd.ms-excel"
          );
          msg.type = "success";
          msg.message = "Export Call Center list successful!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = "Export Call Center list failure!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    exportMSLList() {
      const msg = this.$message({
        message: `User list is exporting...`,
        duration: 0,
      });
      this.axios
        .get(`/user/exportUserList`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = `Export User list successful!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = `Export User list failure!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    filterExportSEList() {
      this.disableExportSEUser = true;
      const msg = this.$message({
        message: "HCP List is exporting...",
        duration: 0,
      });
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
        typeId: this.typeId,
        mlId: this.user,
        province: this.province,
        city: this.city,
      };
      this.axios
        .get("/se/myHcpExport", {
          responseType: "blob",
          params: params
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = "Export HCP List successful!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = "Export HCP List failure!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    exportSEList() {
      this.disableExportSEUser = true;
      const msg = this.$message({
        message: "HCP List is exporting...",
        duration: 0,
      });
      this.axios
        .get("/se/export", {
          responseType: "blob",
          params: {
            exportType: "Hcp",
          },
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = "Export HCP List successful!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = "Export HCP List failure!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    tagTypeParser(flag) {
      let type = ''
      switch (flag) {
        case 0:
          type = 'danger'
          break;
        case 1:
          type = 'success'
          break;
        case 2:
          type = 'warning'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagTypeParserForiDoctor(flag) {
      let type = ''
      switch (flag) {
        case 2:
          type = 'success'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagLabelParserForiDoctor(flag) {
      let label = ''
      switch (flag) {
        case 2:
          label = 'Match'
          break;

        default:
          label = 'Mismatch'
          break;
      }
      return label
    },
    tagLabelParser(flag) {
      let label = ''
      switch (flag) {
        case 0:
          label = 'Uncertified'
          break;
        case 1:
          label = 'Certified'
          break;
        case 2:
          label = 'Pending certification'
          break;

        default:
          label = 'Uncertified'
          break;
      }
      return label
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
        typeId: this.typeId,
        mlId: this.user,
        province: this.province,
        city: this.city,
      };
      this.axios
        .get(`/se/seList`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
            this.toggleRowSelection();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    handleSelect(selection, row) {
      let index = this.multipleSelection.findIndex((SEID) => SEID === row.SEID);
      if (index === -1) {
        this.multipleSelection.push(row.SEID);
      } else {
        this.multipleSelection.splice(index, 1);
      }
    },
    handleSelectionAll(select) {
      if (select.length > 0) {
        let seIds = Array.from(select, (i) => i.SEID);
        let result = seIds.filter((x) => {
          return !this.multipleSelection.some((y) => y === x);
        });
        this.multipleSelection = this.multipleSelection.concat(result);
      } else {
        let seIds = Array.from(this.tableData, (i) => i.SEID);
        seIds = seIds.filter((x) => {
          return this.multipleSelection.some((y) => y === x);
        });
        let result = this.multipleSelection.filter((x) => {
          return !seIds.some((y) => y === x);
        });
        this.multipleSelection = result;
      }
    },
    toggleRowSelection() {
      let rows = this.tableData.filter((i) => {
        return this.multipleSelection.some((SEID) => SEID === i.SEID);
      });
      rows.forEach((row) => {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(row, true);
        });
      });
    },
    onSuccess(resetPage = false) {
      this.orderBy = resetPage ? "CreatedOn" : this.orderBy;
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.multipleSelection = [];
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleEdit(row) {
      this.rowData = row;
      this.editSEDialogVisible = true;
    },
    getQRCode(row) {
      this.rowData = row;
      this.qrTitle = row.Types.indexOf('vCE') > -1 ? 'vCE' : 'SE/CE'
      this.qrcodeDialogVisible = true;
    },
    handleDelete(seId) {
      if (!seId) {
        return;
      }
      this.$confirm("Once deleted, it cannot be recovered.", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          let seIds = [seId];
          this.axios
            .post("/se/freeze", {
              seId: seIds,
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.getTableData();
                this.$message.success("Delete HCP successfully");
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => { });
    },
    handleMultiDelete() {
      if (this.multipleSelection.length === 0) {
        return;
      }
      this.$confirm(
        "Please make sure if it is ready to delete selected HCP(s)?",
        "Attention",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
        }
      )
        .then(() => {
          let seIds = this.multipleSelection;
          this.axios
            .post("/se/freeze", {
              seId: seIds,
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.getTableData();
                this.multipleSelection = [];
                this.$message.success("Delete HCP(s) successfully");
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => { });
    },
    handleTransferSE() {
      const selectedItems = this.tableData.filter(item => this.multipleSelection.includes(item.SEID));
      if (selectedItems.length === 0) return;
      this.seIds = selectedItems.map(item => item.SEID);
      const types = selectedItems[0]?.Types || '';
      const validTypes = ['SE', 'vCE', 'CE'];
      const parts = types.split(',').map(part => part.trim()).filter(part => part !== '');
      let transferType = '';
      for (const part of parts) {
        if (validTypes.includes(part)) {
          transferType = part;
          break;
        }
      }
      this.transferType = transferType;
      this.transferSEDialogVisible = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.call-center-upload-result {
  text-align: center;
  padding: 6px 0;
}

.call-center-upload-row {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-left: 22%;
}
.call-center-upload-value{
  width: auto;
  line-height: 28px;
}
.call-center-upload-label {
  width: 140px; // 固定宽度，保证冒号在同一列
  text-align: right;
  line-height: 28px;
}

.call-center-upload-value {
  min-width: 70px;
  text-align: left;
}

.call-center-export-btn {
  margin-left: 12px;
  padding: 7px 14px;
}

.call-center-upload-row{
  display: flex;
    justify-content: flex-start;
    margin-left: 22%;
}
.mb10 {
  margin-bottom: 10px;
}

.pagination-wrap {
  display: flex;
  justify-content: space-between;

  .actions {
    display: flex;
  }

  .transfer-actions,
  .el-button {
    margin-left: 10px;
  }
}

.ml10 {
  margin-left: 10px;
}

.filter-wrapper.se {
  justify-content: flex-end;
  align-items: center;
  display: flex;
  margin-right: 10px;
}
</style>
